/* Search Functions */
((seach) => {
    const searchInput       = document.getElementById('searchInput')
    const beforeSearchInput = document.getElementById('beforeSearchInput')
    const openSearchBox     = document.getElementById('openSearchBox')
    
    beforeSearchInput.addEventListener('keydown', (evt)=>{
        let searchLength = evt.target.value.length;
        if(searchLength >= 3){
            openSearchBox.dispatchEvent(new Event('click'));
            searchInput.value = evt.target.value;
            searchInput.dispatchEvent(new Event('keypress'));
            evt.target.value = '';
        }
    })
})()
/* End of Search Functions */

// Page Nuestra Historia (Servicebox) 
const serviceboxHistoria = $('#shopify-section-page-servicebox-nuestra-historia .input-group');
    if(serviceboxHistoria != null){
        serviceboxHistoria.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

/* Carrousel for Text Image Row Section - Only in Mobile Device  */
if(window.innerWidth <= 1120){
    const textRowCarrousel = $('.text-image-row');
    if(textRowCarrousel != null){
        textRowCarrousel.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        })
    }
}
/* End of Carrousel for Text Image Row Section */

/* Carrousel for Text Image News Section - Only in Mobile Device  */
if(window.innerWidth <= 1120){
    const textRowCarrousel = $('.custom-section-home-news');
    if(textRowCarrousel != null){
        textRowCarrousel.slick({
            dots: true,
            dotsClass: "dots-news",
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 737,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        })
    }
}
/* End of Carrousel for Text Image Row Section */ 

/* Certificaciones Carrousel only in Certificaciones Page (MOBILE) */
if(window.innerWidth <= 1120){
    const certificacionesCarrousel = $('.certificados-services__cont--wrap-items');
    if(certificacionesCarrousel != null){
        certificacionesCarrousel.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        })
    }
}

// Page Colaborar
const serviceColaborar = $('#serviceColaborar .input-group');
if(serviceColaborar != null){
    serviceColaborar.slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    })
}

/* Gallery with Image or Video */
const galleryImageVideo = $('.gallery-image-video .input-group');
if(galleryImageVideo != null){
    galleryImageVideo.slick({
        infinite: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    })
}

const nuestraHistoria2Carrousel = $('#shopify-section-page-servicebox-nuestra-historia2 .input-group');
if(nuestraHistoria2Carrousel != null){
    nuestraHistoria2Carrousel.slick({
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

const nuestraHistoriaRowImage = $('#shopify-section-text-and-image-row-historia .text-image-row');
if(nuestraHistoriaRowImage != null){
    nuestraHistoriaRowImage.slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
    });
}

/* Certificaciones Carrousel only in Product Certificaciones Page (MOBILE) */
function recomendationCarrouselFun() {
    const recomendationCarrousel = $('.product-recommendations .cont');
    if(recomendationCarrousel != null){
        recomendationCarrousel.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 424,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        })
    }
}

// Page Apadrina
//const apadrinaDeclaraciones = $('.wrap-img-url')
const apadrinaDeclaraciones = $('.banner-declaraciones-apadrina')
    if(apadrinaDeclaraciones != null){
        apadrinaDeclaraciones.slick({
            infinite: false,
            dots: true,
            arrows: true,
            appendArrows: $('.title'),
            adaptiveHeight: true,
            prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" class="slick-prev" width="31.825" height="31.825" viewBox="0 0 31.825 31.825"><defs><style>.a{fill:#fff;fill-rule:evenodd;}</style></defs><g transform="translate(17.504 -9.543) rotate(45)"><path class="a" d="M6.75,16.875A1.125,1.125,0,0,1,7.875,18V28.125H18a1.125,1.125,0,0,1,0,2.25H6.75A1.125,1.125,0,0,1,5.625,29.25V18A1.125,1.125,0,0,1,6.75,16.875Z"/><path class="a" d="M27.8,8.2a1.125,1.125,0,0,1,0,1.593L7.546,30.047a1.126,1.126,0,0,1-1.593-1.593L26.2,8.2a1.125,1.125,0,0,1,1.593,0Z"/></g></svg>',
            nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" class="slick-next" width="31.825" height="31.825" viewBox="0 0 31.825 31.825"><defs><style>.a{fill:#fff;fill-rule:evenodd;}</style></defs><g transform="translate(14.321 41.368) rotate(-135)"><path class="a" d="M6.75,16.875A1.125,1.125,0,0,1,7.875,18V28.125H18a1.125,1.125,0,0,1,0,2.25H6.75A1.125,1.125,0,0,1,5.625,29.25V18A1.125,1.125,0,0,1,6.75,16.875Z"/><path class="a" d="M27.8,8.2a1.125,1.125,0,0,1,0,1.593L7.546,30.047a1.126,1.126,0,0,1-1.593-1.593L26.2,8.2a1.125,1.125,0,0,1,1.593,0Z"/></g></svg>',
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,            
        })


        $('.title .slick-prev').on('click', function() {
        $(apadrinaDeclaraciones).slick('slickPrev');
        });
        $('.title .slick-next').on('click', function() {
        $(apadrinaDeclaraciones).slick('slickNext');
        });
    }

const apadrinaAgradecimientos = $('.banner-apadrina__cont--sect2 .wrap-thanks');
    if(apadrinaAgradecimientos != null){
        apadrinaAgradecimientos.slick({
            infinite: false,
            dots: true,
            arrows: false,
            adaptiveHeight: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,            
        })
    }


// Page certificados
if(window.innerWidth <= 767){
    const serviceCertificados = $('.certificados-services__cont--wrap-items');
    if(serviceCertificados != null){
        serviceCertificados.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}







$(document).ready(function() {
    setTimeout(function(){ 
        recomendationCarrouselFun();
    }, 1500);
    
})